import { VisualizatorSettings } from "../../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../../web-graphics";

export class MeasurerSettings extends VisualizatorSettings {
  constructor(settings) {
    super();

    const simpleFields = ["startWidth", "startPosition", "touchLineAreaWidth", "minLinesSpace"];
    const colorFields = ["leftLineColor", "rightLineColor", "focusedAreaColor", "commonLabelColor", "intermediateAreaColor"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "leftPanelWidth") {
        this.leftPanelWidth = settings.leftPanelWidth.copy();
      } else if (colorFields.includes(key)) {
        this[key] = ObjectCreator.deepCopy(settings[key]);
      } else if (simpleFields.includes(key)) {
        this[key] = settings[key];
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new MeasurerSettings(this);
  }
}
